const API = "https://knowledge-retention-platform-1.onrender.com";
export default API;